import { breakpoints } from '@frontend/responsiveness';

export const DEFAULT_LENGTH = '0px';

export const COLOR_PICKER_PALETTE = [
  '#4D0505',
  '#BD0F0F',
  '#FF584C',
  '#FF837A',
  '#FFB8B3',
  '#FFE3E0',
  '#3F0250',
  '#9D30BC',
  '#C467DE',
  '#D88EEC',
  '#E5AFF3',
  '#F8E3FD',
  '#002152',
  '#0254CF',
  '#3F8BFD',
  '#6BA6FF',
  '#9EC5FF',
  '#DCEBFE',
  '#002533',
  '#006B62',
  '#018479',
  '#22CBC1',
  '#89E1DB',
  '#C2F4F1',
  '#4B2D00',
  '#9A6D16',
  '#BB8A2C',
  '#D3A650',
  '#E3C07D',
  '#F0DBB3',
  '#000000',
  '#5F6771',
  '#8E959E',
  '#A1A8B0',
  '#CED3DA',
  '#FFFFFF',
];

// TODO: Consolidate all the other SIDEBAR_BREAKPOINTS constants throughout the repo
// to use this as the source of truth. Also consider better alternatives.
export const COMPOSER_BREAKPOINTS = {
  MOBILE: 650,
  TABLET: breakpoints.medium.min,
  DESKTOP: breakpoints.medium.max,
};
